import React from 'react';
import Home from '../Home/Home';

const Header = () => {
   return (
      <div>
         <Home></Home>
      </div>
   );
};

export default Header;
